import { render } from "./OrderRouter.vue?vue&type=template&id=e195054e"
import script from "./OrderRouter.vue?vue&type=script&lang=js"
export * from "./OrderRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__